const messages = {
  header: "Ops!",
  subheader_firstLine: "Página indisponível.",
  subheader_secondLine: "O que pode ter acontecido?",
  cta_cobli_website: "Conheça a Cobli agora",
  reason_1_header: "O endereço já foi visitado há mais de uma hora.",
  reason_1_text: "Vale a pena conferir!",
  reason_2_header: "O link foi gerado há mais de 24 horas.",
  reason_2_text:
    "Neste caso basta pedir que seu fornecedor gere o link e te envie novamente."
};

export default messages;
